// Mount the Waap module: hand `createWaapModule` a lazy host (`./waap-host`, which holds the heavy
// app imports) instead of a built one. `service-modules.ts` and `service-scopes.ts` take the routes
// and the catalog scope from HERE, so the module cannot be mounted unregistered. This file must stay
// light: it is in the entry chunk. The HTTP client is not a member: the module reads it from the
// shared registry (`@vnetwork/margarita-core/http`).
import { createWaapModule } from '@vnetwork/margarita-waap';

export const waap = createWaapModule(() => import('./waap-host').then((m) => m.waapHost));
